/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Create_DescriptionInputs */

const en_admin_roles_create_description = /** @type {(inputs: Admin_Roles_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define a new system role`)
};

const zh_admin_roles_create_description = /** @type {(inputs: Admin_Roles_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定义一个新的系统角色`)
};

/**
* | output |
* | --- |
* | "Define a new system role" |
*
* @param {Admin_Roles_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_create_description = /** @type {((inputs?: Admin_Roles_Create_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Create_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_create_description(inputs)
	return zh_admin_roles_create_description(inputs)
});
export { admin_roles_create_description as "admin.roles.create_description" }